"use strict";
/**
 * Pattern Database Record Types
 *
 * Based on actual backend implementation (CDK data-models.ts)
 * Authoritative source for pattern component structure
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatternComponentType = void 0;
// Pattern Component Type Enum
var PatternComponentType;
(function (PatternComponentType) {
    PatternComponentType["TEXT_ONLY"] = "text_only";
    PatternComponentType["IMAGE_LEFT_TEXT_RIGHT"] = "image_left_text_right";
    PatternComponentType["TEXT_LEFT_IMAGE_RIGHT"] = "text_left_image_right";
    PatternComponentType["MULTI_IMAGE"] = "multi_image";
    PatternComponentType["TIP"] = "tip";
    PatternComponentType["CAUTION"] = "caution";
    PatternComponentType["IMPORTANT"] = "important";
})(PatternComponentType || (exports.PatternComponentType = PatternComponentType = {}));
